"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntrySchema = exports.UserLogDTO = exports.UserLogDTOSchema = exports.UserLogSchema = exports.UserLogBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
exports.UserLogBaseSchema = zod_1.z.object({
    Entry: zod_1.z
        .string()
        .min(5, 'The log entry should have at least 5 letters')
        .max(240, 'The log entry should have less than 240 letters'),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    AuthorId: zod_1.z.instanceof(ObjectId_1.ObjectId),
});
exports.UserLogSchema = exports.UserLogBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.UserLogDTOSchema = exports.UserLogSchema.extend(__assign({ UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), AuthorId: (0, ObjectId_1.ObjectIdString)('Invalid UserId') }, CommonMongoModelFields_1.CommonModelDTOFields));
exports.UserLogDTO = {
    convertFromModel: function (model) {
        var _a;
        var dto = {
            Entry: model.Entry,
            createdAt: model.createdAt,
            AuthorId: (_a = model.AuthorId) === null || _a === void 0 ? void 0 : _a.toString(),
            Author: (0, ObjectId_1.isPopulated)(model.AuthorId) ? User_1.UserDTO.convertFromModel(model.AuthorId) : undefined,
            UserId: model.UserId.toString(),
            _id: model._id.toString(),
            updatedAt: model.updatedAt,
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
        };
        return dto;
    },
};
exports.EntrySchema = zod_1.z.object({
    entry: exports.UserLogBaseSchema.shape.Entry,
});
//# sourceMappingURL=UserLog.js.map